import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../utils/cn";

const containerVariants = cva("w-full flex flex-col", {
    variants: {
        maxWidth: {
            sm: "max-w-screen-sm",
            md: "max-w-screen-md",
            lg: "max-w-screen-lg",
            xl: "max-w-screen-xl",
            "2xl": "max-w-screen-2xl",
            full: "max-w-full",
        },
        padding: {
            none: "px-0",
            sm: "px-4",
            md: "px-4 sm:px-6 lg:px-8",
            lg: "px-8 sm:px-10 lg:px-12",
        },
        align: {
            left: "items-center sm:items-start",
            center: "items-center",
            right: "items-center sm:items-end",
        },
    },
    defaultVariants: {
        maxWidth: "xl",
        padding: "none",
    },
});

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof containerVariants> {}

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
    ({ className, maxWidth, padding, align, ...props }, ref) => (
        <div ref={ref} className={cn(containerVariants({ maxWidth, padding, align, className }))} {...props} />
    ),
);
Container.displayName = "Container";

export { Container, containerVariants };
